<div class="dialog-close" cdkFocusInitial (click)="cancel()"></div>

<h1 mat-dialog-title>
  {{ data.title }}
</h1>

<div class="dashboard-chips" mat-dialog-content>
  <mat-form-field class="dashboard-chips-form">
    <mat-chip-grid #emailOpts>
      @for (chip of data.chips; track chip) {
        <mat-chip-row [removable]="data.removable" (removed)="remove(chip)">
          {{chip}}
          @if (data.removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-row>
      }
      @if (data.addEmailPermission) {
        <input id="email-input"
          placeholder="+ Add email address"
          type="email"
          [formControl]="emailCtrl"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputFor]="emailOpts"
          (matChipInputTokenEnd)="add($event.value)"
          (paste)="paste($event)">
      }
    </mat-chip-grid>
  </mat-form-field>

  @if (emailCtrl?.invalid && (emailCtrl?.dirty || emailCtrl?.touched) && emailCtrl?.errors?.['invalidEmail']) {
    <mat-error
      class="margin-t-20 margin-b-8">
    Please enter valid email address</mat-error>
  }

  @if (data.message) {
    <div class="message" [innerHTML]="data.message"></div>
  }
  @if (data.extra_message) {
    <div class="info-message">
      <img [src]="infoIcon" alt="" width="16" height="16">
      <span [innerHTML]="data.extra_message"></span>
    </div>
  }

</div>
<div mat-dialog-actions class="ui-layout" ui-layout-align="end">
  <button mat-button class="dashboard-button" (click)="cancel()">{{ data.cancelText }}</button>
  <button mat-button class="dashboard-button confirm focused"
    (click)="confirm()"
    [disabled]="(!data.chips.length && !emailCtrl.value.length) || (emailCtrl?.dirty || emailCtrl?.touched) && emailCtrl?.errors?.['invalidEmail']">{{ data.confirmText }}
  </button>
</div>
